/**
 * Branding is configuration, not code: change the product name, tagline and
 * theme colours here without touching any screen.
 */
export const brand = {
  id: 'obigo',
  /** Shown as written in every language (an Arabic spelling can be set for `ar`). */
  name: { ar: 'ObiGo', fr: 'ObiGo', en: 'ObiGo' },
  domain: 'obigo.tn',
  tagline: {
    ar: 'نتعلّم، نلعب، ونكبر كل يوم.',
    fr: 'On apprend, on joue, on grandit chaque jour.',
    en: 'We learn, we play, we grow every day.',
  },
  /** Used by the web manifest and the browser UI (sky blue of the logo). */
  themeColor: '#3b8fe0',
  backgroundColor: '#fffaf0',
} as const;

export type Brand = typeof brand;
